<ion-app>
    <ion-split-pane when="xl" contentId="main-content">
        <ion-menu contentId="main-content" type="overlay">
            <ion-content>
                <ion-list id="inbox-list">
                    <ion-list-header>Convator App</ion-list-header>
                    <ion-note>v.{{global.version}}</ion-note>

                        <ng-container *ngFor="let p of appPages; trackBy: trackByMenuId">
                            <ion-item-divider *ngIf="!p.hide && p.divider">
                                <ion-label></ion-label>
                            </ion-item-divider>

                            <ion-item
                                *ngIf="!p.hide && !p.divider"
                                routerDirection="root"
                                [routerLink]="[p.url]"
                                lines="none"
                                detail="false"
                                routerLinkActive="selected"
                                (click)="closeMenu()"
                            >
                                <ion-icon slot="start" [name]="p.icon"></ion-icon>
                                <ion-label>
                                    {{ p.title }}
                                </ion-label>
                            </ion-item>
                        </ng-container>

                </ion-list>
            </ion-content>
        </ion-menu>
        <ion-router-outlet id="main-content"></ion-router-outlet>
    </ion-split-pane>
</ion-app>
